import React from 'react';
import i18next from "./i18n.js";

export const UserContext = React.createContext();
export const ScrollContext = React.createContext();
export const urls = {
    loginPage: '/login',
    registerPage: '/register',
    recoveryPasswordPage: '/password-recovery',
    restorePasswordPage: '/restorepassword',
    profilePage: '/profile',
    documentsPage: '/documents',
    tasksPage: '/tasks',
    newVacationPage: '/documents/new-vacation',
    newCertificationPage: '/documents/new-certification',
    newBusinessTripPage: '/documents/new-business-trip',
    newDetailsPage: '/documents/new-details',
    newTransferRequestPage: '/documents/new-transfer-request',
    errror500Page: '/500',
    mainPage: '/',
    calendarPage: '/calendar',
    schedulePage: '/schedule',
    successfullySignPage: '/success',
    privacyPage: '/privacy.html',
}
export const actionTypes = {
    sign: 'signFolderContent',
    cancel: 'reject',
    accept: 'accept',
    resign: 'toAutor',
    close: 'close',
    delete: 'delete',
    edit: 'edit',
    send: 'send',
    cancelEdit: 'cancelEdit',
    approve: 'approve',
    refinement: 'refinement',
    signAdditionalContent: 'signAdditionalContent',
    reviewed: 'familiarized'
}
export const constants = {
    allowedInfoFileExtensions: ['pdf'],
    acceptInfoIputFileString: "application/pdf",
    placeholderDialogId: "placeholder-modal-dialog",
    otherTripGoalValue: "other"
}
export const allowedAdditionalFileExtensions = ["pdf", "png", "jpg", "jpeg", "bmp", "txt", "doc", "docx", "rtf"];
export const acceptAdditionalInputFileString = "application/pdf,image/png,image/jpeg,image/bmp,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/rtf";
export const allowedImageFileExtensions = ["png", "jpg", "jpeg", "bmp"];
export const acceptImageFileString = "image/png,image/jpeg,image/bmp"

export const statusFieldColors = {
    "Default": "rgba(84, 188, 235, 0.2)",
    "Selected": "rgba(244, 123, 32, 0.2)",
    "Не підписано": "#FDE5D3",
    "Активний": "#CDF2DA",
    "Заблокований": "#F2D6D1",
    "Підтвердження пошти": "#FFF5CE"
}
export const companyTypes = {
    Entity: 'caLegal',
    Individual: 'caFOP'
}
export const companyTypeTitles = {
    Entity: 'Юридична особа',
    Individual: 'ФОП'
}
export const companyTypeValues = [
    {
        title: companyTypeTitles.Entity,
        value: companyTypes.Entity
    },
    {
        title: companyTypeTitles.Individual,
        value: companyTypes.Individual
    }
]
export const formFieldTypes = {
    select: "select",
    int: "int",
    bool: "bool",
    string: "string",
    datetime: "datetime",
    phone: "phone",
    file: "file",
    empty: "empty",
    user: "user",
    userInput: "userinput",
    state: "state",
    dateInterval: "dateInterval",
    daysCount: "dayscount",
    crop: "crop",
    email: "email",
    label: "label",
    attachments: "attachments",
    group: "group",
    formGroup: "formgroup",
    tabsGroup: "tabsgroup",
    subform: "subform",
    warningcheckbox: "warningcheckbox",
    doublecheckbox: "doublecheckbox",
    documents: "documents",
    info: "info",
    destination: "destination",
    startingPoint: "startingpoint",
    dateIntervalInput: "dateinterval",
    switcher: "switcher",
    collapsedSelect: "collapsedselect",
    radioButtonGroup: "radiobuttongroup",
    transportSelect: "transportselect",
    route: "route",
    infoBox: "infobox",
    textInfo: "textinfo",
    tripSummary: "tripsummary"
}
// Типи полів, які не мають заголовка або показують його самі
export const hiddenLabelFieldTypes = [formFieldTypes.subform, formFieldTypes.destination, formFieldTypes.startingPoint,
formFieldTypes.switcher, formFieldTypes.route, formFieldTypes.infoBox, formFieldTypes.textInfo]
// Типи полів без значення, тому в них нічого перевіряти
export const noValueFieldTypes = [formFieldTypes.infoBox, formFieldTypes.textInfo]
// Типи полів, значення яких є об'єктом зі значеннями полів документа, перелічених у Settings
export const settingsValueFieldTypes = [formFieldTypes.startingPoint, formFieldTypes.dateIntervalInput, formFieldTypes.route]
// Види елементів, які користувач додає в поле attachments з AllowLinks
export const attachmentTypes = {
    file: "file",
    link: "link"
}
export const formStringFieldPatterns = {
    phone: "phone",
    email: "email",
    codeIPN: "ipn",
    codeEDRPO: "codeEDRPO",
    mFO: "mFO",
    legalPersonIPN: "legalPersonIPN",
    number: "number",
    integer: "integer",
    iBan: "iBan",
    crop: "crop",
    mobile: "mobile",
    bankCard: "bankCard",
    float: "float"
}
export const counterpartyKind = {
    OtherPartners: "Other Partners",
    OwnCompany: "Own Company",
    Mediator1: "Mediator 1",
    Mediator2: "Mediator 2",
    Maker: "Maker"
}
export const settingsFormTypes = {
    settingsType: 'settings',
    adminType: 'admin'
}
export const statutoryDocTypes = {
    statutory: 0,
    template: 1,
    announcement: 2
}
export const filterOperatioTypes = {
    And: 0,
    Or: 1
}
export const listTypes = {
    Documents: 0,
    Tasks: 1,
    Users: 2,
    News: 3,
    Notifications: 4,
    Certifications: 5,
    BusinessTrips: 6,
    Widgets: 7,
    TransferRequests: 8
}
export const formModes = {
    all: "all",
    create: "create",
    read: "read",
    edit: "edit",
}
export const attachmentStatuses = {
    noDoc: "noDoc",
    NotAdded: "not_add",
    New: "new",
    Signed: "signed"
}
export const filterDividers = {
    FilterPartsDivider: 'ˍ',
    FilterValuesDivider: '`',
    FilterNameValueDivider: '^'
}
export const alfrescoTypes = {
    vacationClaim: "sx:claimVacation",
    user: "cm:person",
    certification: "sx:Certification",
    businessTrip: "sx:businessTrip",
    details: "sx:details",
    businessTripPlace: "sx:PlaceBusinessTrip",
    travelLetterAuto: "sx:TravelLetterAuto",
    advanceReport: "sx:AdvanceReport",
    transferRequest: "sx:transferRequest",
    unstructuredDocument: "sx:unstructuredDocument",
    transitTripPlace: "sx:transitTripPlace"
}
export const businessTripAttachmentFileTypes = {
    ipn: 'TaxID',
    other: 'other',
    carRentalAgreement: 'carRentalAgreement',
    carRentalInvoice: 'CarRentalInvoice',
    vehicleCertificate: 'vehicleCertificate',
    foreignPassport: 'foreignPassport'
}
export const signatureStates = {
    signed: "1"
}
export const paginationSettings = {
    swiperItenmsCount: 5
}
export const documentStatuses = {
    template: 'Template',
    formationsigningOrder: 'formationsigningOrder',
    signingOrderEmployee: 'SigningOrderEmployee',
    archived: 'ARCHIVED',
    enteringInfo: 'entering_info', //Внесення додаткової інформації автором
    refinement: 'refinement', //На доопрацюванні ініціатором
    processingTravelLetterAuto: 'processing_travel_letter_auto', //Обробка подорожнього листа
    formationReport: 'formation_report', //Формування авансового звіту
    refinementAdvanceReport: 'refinement_advance_report', //На доопрацюванні відряджуваним (Авансовий звіт)
    refinementSeconded: 'refinement_seconded', //На доопрацюванні відряджуваним (Подорожній лист)
    signingAdvanceReport: 'signing_advance_report',
    signingReportSeconded: 'signing_report_seconded', //На підписанні відряджуваним авансового звіту
    signingSeconded: 'signing_seconded', //Підписання заявки та наказу відряджуваним
    signingAdvanceReportAccounting: 'signing_advance_report_accounting', //На підписанні бухгалтером
    processing: 'processing', //Обробка заявки
    processingHead: 'processing_head', //Погодження відрядження керівником відряджуваного
    sending: 'sending', //Відправка оригіналу довідки Автору
    preparing: 'preparing', //Підготовка
    approvingSeconded: 'approving_seconded' //Погодження запропонованих квитків відряджуваним
}
export const documentBpActions = {
    activitiprocessAccreditationCA: "activiti$processAccreditationCA",
    activitiProcessDocCA: "activiti$processDocCA1",
    completeCounterpartyCorrections: "activiti$completeCounterpartyCorrections",
    activiti$processInvoice: "activiti$processInvoice",
    activiti$returnContractToCorrections: "activiti$returnContractToCorrections",
    activiti$completeContractsSigning: "activiti$completeContractsSigning",
}
export const initiatorSystem = {
    COFCO: "COFCO",
    PORTAL: "PORTAL"
}
export const resources = {
    pricesTemplateFileName: 'PricesTemplate.xlsx',
    loadingIcone: '/img/loading.svg',
    logoutIcone: '/img/logout.svg',
    defaulUserImg: '/img/defaulUser.png',
    userInstructionFileName: 'instruction'
}
export const maxFileSize = 47190000;
export const leftMenuTypes = {
    divider: 'divider',
    link: 'link'
}

export const menuTypes = {
    desktop: 'desktop',
    main: 'main',
    create: 'create',
    signDoc: 'sign',
    close: 'close',
    closeDesktop: 'closeDesktop',
    crop: 'crop'
}

export const menuNavigationTypes = {
    link: 'link',
    tab: 'tab',
    menu: 'menu'
}

export const menuTabKeys = {
    save: 'save',
    cancel: 'cancel',
    sign: 'sign',
    main: 'main',
    tasks: 'tasks',
    documents: 'documents',
    calendar: 'calendar'
}

export const mainMenuItems = [
    {
        Title: 'Головна',
        IconUrl: '/img/navigation/main.svg',
        Type: menuNavigationTypes.link,
        TargetUrl: urls.mainPage,
        Key: menuTabKeys.main
    },
    {
        Title: 'Завдання',
        IconUrl: '/img/navigation/tasks.svg',
        Type: menuNavigationTypes.link,
        TargetUrl: urls.tasksPage,
        Key: menuTabKeys.tasks
    },
    {
        Title: 'Документи',
        IconUrl: '/img/navigation/documents.svg',
        Type: menuNavigationTypes.link,
        TargetUrl: urls.documentsPage,
        Key: menuTabKeys.documents
    },
    {
        Title: 'Календар',
        IconUrl: '/img/navigation/calendar.svg',
        Type: menuNavigationTypes.link,
        TargetUrl: urls.calendarPage,
        Key: menuTabKeys.calendar
    }
]

export const createMenuItems = [
    {
        Title: 'Зберегти',
        IconUrl: '/img/other/ok.svg',
        Type: menuNavigationTypes.menu,
        Key: menuTabKeys.save
    },
    {
        Title: 'Скасувати',
        IconUrl: '/img/other/cancel.svg',
        Type: menuNavigationTypes.menu,
        Key: menuTabKeys.close
    },
]

export const signTemplateActions = [
    {
        title: 'Підписати',
        type: actionTypes.sign
    },
    {
        title: 'Скасувати',
        type: actionTypes.delete
    },
]

export const createTemplateActions = [
    {
        title: 'Зберегти',
        type: actionTypes.save
    },
    {
        title: 'Скасувати',
        type: actionTypes.close
    },
]

export const closeMenuItems = [
    {
        Title: 'Закрити',
        IconUrl: '/img/other/close.svg',
        Type: menuNavigationTypes.menu,
        Key: menuTabKeys.close
    },
]

export const menuItems = {}
menuItems[menuTypes.desktop] = mainMenuItems;
menuItems[menuTypes.main] = mainMenuItems;
menuItems[menuTypes.create] = createMenuItems;
menuItems[menuTypes.close] = closeMenuItems;

export const actionTitles = [
    {
        type: "sign",
        title: "Підписати"
    },
    {
        type: "approve",
        title: "Узгодити"
    },
    {
        type: "cancel",
        title: "Скасувати"
    }
]

export const signTypes = {
    diia: 0,
    smartId: 1,
    monobank: 2
}

export const vacationKinds = {
    main: 'vacationMain',
    unpaid: 'vacationUnpaid',
    martiallaw: 'vacationMartiallaw',
    paternity: 'vacationPaternity',
    additionalChildcare: 'vacationAdditionalChildcare',
    sick: 'vacationSick',
    childcare3: 'vacationChildcare3',
    childcare6: 'vacationChildcare6',
    study: 'vacationStudy',
    chaes: 'vacationChaes',
    ubd: 'vacationUbd'
}

export const certificationKinds = {
    other: 'Other',
    incomeCertificate: 'incomeCertificate',
    employmentCertificate: 'Employment certificate',
    copyOfEmploymentContract: 'Copy of employment contract',
    characteristic: 'Characteristic'
}

export const unstructuredDocumentKinds = {
    claim: 'claim',
    contract: 'contract',
    order: 'order',
    other: 'other',
    letters: 'letters'
}

export const unstructuredDocumentSubkindsClaim = {
    bookHand: "bookHand", //Заява на видачу трудової книжки
    vacation: "vacation", //Заява на відпустку
    out: "out", //Заява на звільнення
    surname: "surname", //Заява на зміну прізвища
    mobilization: "mobilization", //Заява на компенсацію відпустки при мобілізації
    transfer: "transfer", //Заява на переведення
    maternity: "maternity", //Заява на переривання декретної відпустки
    bookMail: "bookMail", //Заява на пересилку трудової книги
    in: "in", //Заява на прийом на роботу
    dismiss: "dismiss", //Заява на увільнення для здачі крові
    bank: "bank", //Заява про зміну реквізитів
    payment: "payment", //Заява про перерахунок ЗП на карту
    remote: "remote", //Заява про укладення договору дистанційної роботи
}

export const unstructuredDocumentSubkindsContract = {
    remote: "remote", //Договір про віддалену роботу
    responsibility: "responsibility", //Договір про матеріальну відповідальність
    data: "data", //Згода на обробку персональних даних
    employment: "employment", //Трудовий договір/контракт
    nda: "nda", //Угода про нерозголошення службової інформації
}

export const unstructuredDocumentSubkindsOrder = {
    workSchedule: "workSchedule", //Графік роботи
    deputyAppeal: "07", //Депутатське звернення
    deputyInquiry: "08", //Депутатський запит
    remote: "remote", //Заява про укладення договору дистанційної роботи
    responsibility: "responsibility", //Договір про матеріальну відповідальність
    document: "16", //Документ
    assignment: "11", //Доручення
    law: "09", //Закон
    application: "01", //Заява
    applicationAlt: "101", //Заява
    bookHand: "bookHand", //Заява на видачу трудової книжки
    vacation: "vacation", //Наказ на відпустку
    out: "out", //Наказ на звільнення
    surname: "surname", //Наказ про зміну прізвища
    mobilization: "mobilization", //Заява на компенсацію відпустки при мобілізації
    transfer: "transfer", //Наказ на переведення
    maternity: "maternity", //Заява на переривання декретної відпустки
    bookMail: "bookMail", //Заява на пересилку трудової книги
    in: "in", //Наказ на прийом на роботу
    dismiss: "dismiss", //Наказ на увільнення
    bank: "bank", //Заява про зміну реквізитів
    payment: "payment", //Заява про перерахунок ЗП на карту
    data: "data", //Згода на обробку персональних даних
    petition: "104", //Клопотання
    letter: "04", //Лист
    reminder: "05", //Нагадування
    donation: "donation", //Наказ по донору
    start: "start", //Наказ про виведення на роботу: з декрету/демобілізація
    P2Form: "P2Form", //Особова картка П-2
    jobDescription: "jobDescription", //Посадова інструкція
    resolution: "10", //Постанова
    proposal: "03", //Пропозиція
    proposalAlt: "103", //Пропозиція
    order: "13", //Розпорядження
    decision: "15", //Рішення
    odaBoardDecision: "12", //Рішення Колегії ОДА
    complaint: "02", //Скарга
    complaintAlt: "102", //Скарга
    telegram: "14", //Телеграма
    employment: "employment", //Трудовий договір/контракт
    nda: "nda", //Угода про нерозголошення службової інформації
    decree: "06", //Указ
}

export const unstructuredDocumentSubkindsOther = {
    workSchedule: "workSchedule", //Графік роботи
    P2Form: "P2Form", //Особова картка П-2
    jobDescription: "jobDescription", //Посадова інструкція
}

export const vacationTypes = {
    vacation: 'vacation',
    businessTrip: 'businessTrip'
}

export const hubEventTypes = {
    documentSigned: 'DocumentSigned',
    documentSignedError: 'DocumentSignedError',
    documentSignCanceled: 'DocumentSignCanceled',
    missedMessages: 'MissedMessages',
    notificationAdded: 'NotificationAdded',
    notificationViewed: 'NotificationViewed',
    profileUpdated: 'ProfileUpdated'
}
export const customEventTypes = {
    onSearch: 'onSearch',
    onSearchChanged: 'onSearchChanged',
    onReturnToPage: 'onReturnToPage',
    onSignStarted: 'onSignStarted',
    onShowMessage: 'onShowMessage',
    onSubformError: 'onSubformError'
}
export const fileLoadTypes = {
    original: 'original',
    view: 'view',
    withSigns: 'withSigns'
}
export const signalRRecconectInterval = 1000;
export const signStatuses = {
    notSigned: 0,
    signed: 1,
    cancaled: 2,
    error: 3
}
export const backgroundTypes = {
    general: 'general',
    main: 'main',
    account: 'account'
}
export const documentTabKeys = {
    general: 'general',
    comments: 'comments'
}
export const notificationTypes = {
    stateChanged: 'newDocumentState',
    newTask: 'newTask',
    newComment: 'newComment',
    reminder: 'newReminder',
    rejected: 'rejected'
}

export const fileIcons = {
    pdf: '/img/fileIcons/pdf.svg',
    excel: '/img/fileIcons/excel.svg',
    doc: '/img/fileIcons/doc.svg',
    image: '/img/fileIcons/img.svg',
    default: '/img/fileIcons/default.svg'
}

export const docTypeSearchParams = {
    vacationClaim: "vacation",
    certification: "certification",
    businessTrip: "businessTrip",
    details: "details",
    transferRequest: "transferRequest",
    other: "other"
}

export const deliveryPlaces = {
    hr: "HR",
    np: "NP",
    delivery: "delivery",
    tt: "TT",
    ukrPost: "UkrPost"
}

// Маска номера телефону: після фіксованого «+38(0» вводяться лише цифри —
// дві коду оператора і сім самого номера
export const phoneInputMask = '+38(0__) ___ __ __'

// Поля, які уточнюються в діалозі після вибору місця доставки. Усі вони обов'язкові.
// Поле з mask вводиться за маскою і має бути заповнене повністю.
export const deliveryPlaceFields = {
    [deliveryPlaces.np]: [
        { name: 'sx:btAddress', placeholder: 'Місто' },
        { name: 'sx:btBranchNumber', placeholder: 'Номер відділення' },
        { name: 'sx:btNumber', placeholder: '+38(0XX) XXX XX XX', mask: phoneInputMask }
    ],
    [deliveryPlaces.ukrPost]: [
        { name: 'sx:btIndex', placeholder: 'Місто та індекс' },
        { name: 'sx:btNumberU', placeholder: '+38(0XX) XXX XX XX', mask: phoneInputMask }
    ],
    [deliveryPlaces.tt]: [
        { name: 'sx:btPointLocation', placeholder: 'Номер магазину' }
    ]
}
// Ім'я, під яким значення з діалогу доставки передаються в inputChangeHandler одним об'єктом
export const deliveryPlaceValuesName = 'deliveryPlaceValues'

export const tripDestinations = {
    abroad: 'Abroad',
    ukraine: 'Ukraine'
}
export const routeCreatingTypes = {
    auto: 'automatic',
    custom: 'manual'
}
export const employeeCompanies = {
    profitablePurchase: 'Tov', //ТОВ Вигідна покупка
    sevenA: 'TOV2', //ТОВ СЕВЕН А
    promislova: 'TOV3', //ТОВ ПРОМИСЛОВА 9
    technicalServicePlus: 'TOV4' //ТОВ ТЕХНІЧНИЙ СЕРВІС ПЛЮС
}

export const transportationMethods = {
    autoColleagues: 'autoColleagues',
    ownCar: 'ownCar',
    corporateCar: 'corporateCar',
    carRental: 'carRental',
    bus: 'bus',
    train: 'train',
    plane: 'plane'
}

export const roomTypes = {
    single: 'Single',
    double: 'Double'
}

export const businessTripFileTypes = {
    childStatement: 'childStatement',
    registrationCertificate: 'registrationCertificate',
    foreignPassport: 'foreignPassport',
    paymentInvoice: 'paymentInvoice',
    leaseDeed: 'leaseDeed',
    claimForCompensation: 'claimForCompensation',
    other: 'other'
}

export const businessTripFolderSettiongs = [
    {
        title: '01. Заяви',
        label: 'Заяви',
        generated: true
    },
    {
        title: '02. Накази та кошториси',
        label: 'Накази та кошториси',
        generated: true
    },
    {
        title: '03. Авансовий звіт',
        label: 'Авансовий звіт',
        generated: true
    },
    {
        title: '04. Транспортні документи',
        label: 'Транспортні документи',
        fileTypes: [businessTripFileTypes.registrationCertificate, businessTripFileTypes.paymentInvoice, businessTripFileTypes.leaseDeed],
        required: true,
        description: 'Потрібно надати наступні документи: {0}'
    },
    {
        title: '05. Особисті документи',
        label: 'Особисті документи',
        fileTypes: [businessTripFileTypes.foreignPassport],
        required: true,
        description: 'Потрібно надати наступні документи: Закордонний паспорт'
    },
    {
        title: '06. Подорожній лист',
        label: 'Подорожній лист'
    },
    {
        title: '07. Інше',
        label: 'Інше',
        generated: true
    },
]

export const banks = {
    mono: 'Mono',
    privat: 'Privat'
}

export const vacationMinLength = [
    {
        type: vacationKinds.additionalChildcare,
        length: 10
    },
    {
        type: vacationKinds.ubd,
        length: 14
    },
    {
        type: vacationKinds.chaes,
        length: 16
    }
]

export const minDateValue = new Date(-8640000000000000);

export const ukraineCountryValue = '230';

export const transferRequestPositions = ['000000095', '000000096', '000000129', '000000130', '000000077'];
export const juniorSalesConsultantPosition = '000000252';